export default __webpack_public_path__ + "static/media/ubIcon.f94f3fb6.svg";